import { render, staticRenderFns } from "./indicatorsAllocation.vue?vue&type=template&id=214ac69d&scoped=true"
import script from "./indicatorsAllocation.vue?vue&type=script&lang=js"
export * from "./indicatorsAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ac69d",
  null
  
)

export default component.exports